// extracted by mini-css-extract-plugin
module.exports = {"categories":"Categories_categories__20Mw_","item":"Categories_item__100O4","category":"Categories_category__2nZuM","scroll_controls":"Categories_scroll_controls__3OGoU"};